import {
  Modal,
  ModalContent,
  ModalHeader,
} from '@fountain/fountain-ui-components';
import React, { VFC } from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from './messages';

export interface InviteEvaluatorsModalProps {
  applicantId: string;
  scorecardTemplateId: string;
  scorecardName: string;
  handleClose: () => void;
}

// Evaluator invitation arrives with the Invite Evaluators milestone; this
// shell owns the open/close plumbing and the context that flow needs.
export const InviteEvaluatorsModal: VFC<InviteEvaluatorsModalProps> = ({
  applicantId,
  scorecardTemplateId,
  scorecardName,
  handleClose,
}) => (
  <Modal
    data-testid="invite-evaluators-modal"
    ariaLabelledBy="invite-evaluators-modal-header"
    open
    onClose={handleClose}
    fullScreenOnMobile
    maxWidth={480}
  >
    <ModalHeader
      onClose={handleClose}
      ariaLabelledBy="invite-evaluators-modal-header"
      showIcon={false}
    >
      <FormattedMessage {...messages.inviteEvaluators} />
    </ModalHeader>
    <ModalContent
      data-applicant-id={applicantId}
      data-scorecard-template-id={scorecardTemplateId}
      data-scorecard-name={scorecardName}
    />
  </Modal>
);
